"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "container mx-auto" };
const _hoisted_2 = { class: "flex justify-center" };
const _hoisted_3 = { class: "reservation-modal" };
const _hoisted_4 = { class: "modal-body" };
const _hoisted_5 = { class: "modal-content" };
const _hoisted_6 = { value: "" };
const _hoisted_7 = ["value", "selected"];
const _hoisted_8 = { value: "" };
const _hoisted_9 = ["value", "selected"];
const _hoisted_10 = { value: "" };
const _hoisted_11 = ["value", "selected"];
const _hoisted_12 = { value: "" };
const _hoisted_13 = ["value", "selected"];
const _hoisted_14 = { key: 0 };
const _hoisted_15 = ["value", "selected"];
const _hoisted_16 = { class: "radio-container" };
const _hoisted_17 = { class: "checkbox-container" };
const _hoisted_18 = {
    key: 0,
    value: "0",
    selected: "",
    disabled: ""
};
const _hoisted_19 = {
    key: 1,
    value: "0"
};
const _hoisted_20 = ["value"];
const _hoisted_21 = { class: "appointments-title" };
const _hoisted_22 = {
    key: 0,
    class: "appointments"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "appointments-title" };
const _hoisted_25 = {
    key: 0,
    class: "appointments"
};
const _hoisted_26 = ["onClick"];
const wheelSizeStore_1 = require("../../../../stores/wheelSize/wheelSizeStore");
const ServicesStore_1 = require("../../../../stores/services/ServicesStore");
const vue_3 = require("vue");
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const Form_1 = require("../../../../components/Form");
const CustomSelect_vue_1 = __importDefault(require("../../../../components/backend/CustomSelect.vue"));
const CustomTextArea_vue_1 = __importDefault(require("../../../../components/backend/CustomTextArea.vue"));
const CustomRadioWithImage_vue_1 = __importDefault(require("../../../../components/backend/CustomRadioWithImage.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../../components/backend/CustomButton.vue"));
const ReservationModalColumn_vue_1 = __importDefault(require("./ReservationModalColumn.vue"));
//import FileInput from "../../../../components/backend/CustomFileInput.vue";
//import FileInput2 from "../../../../components/Form/FileInput.vue";
const CustomCheckbox_vue_1 = __importDefault(require("../../../../components/backend/CustomCheckbox.vue"));
const ModalBooking_vue_1 = __importDefault(require("./ModalBooking.vue"));
const ModalStatus_vue_1 = __importDefault(require("./ModalStatus.vue"));
const vue_datepicker_1 = __importDefault(require("@vuepic/vue-datepicker"));
require("@vuepic/vue-datepicker/dist/main.css");
const i18n_1 = __importDefault(require("../../../../common/i18n"));
const i18n_2 = require("../../../../common/i18n");
const appointmentStore_1 = require("../../../../stores/appointment/appointmentStore");
const addDays_1 = __importDefault(require("date-fns/addDays"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ReservationModal',
    props: {
        isOpen: {
            type: Boolean,
            default: true,
        },
        appointmentDatas: {
            type: Object,
            default: null,
        },
    },
    emits: [
        "close",
        "approveAppointment",
        "declineAppointment",
        "saveAppointment",
        "deleteAppointment",
    ],
    setup(__props, { emit }) {
        const props = __props;
        const currentLang = (0, vue_3.computed)(() => i18n_2.i18n.locale.value);
        //import { useBookedAppointmentsStore } from "../../../../stores/backend/bookedAppointments/bookedAppointmentsStore";
        //const appointmentsStore = useBookedAppointmentsStore();
        const wheelSizeStore = (0, wheelSizeStore_1.useWheelSizeStore)();
        const servicesStore = (0, ServicesStore_1.useServicesStore)();
        const tipusActive = (0, vue_3.ref)(false);
        const gyartEvActive = (0, vue_3.ref)(false);
        const kivitelActive = (0, vue_3.ref)(false);
        const calendarSelectedDate = (0, vue_3.ref)(new Date());
        const appointmentDatasCopy = (0, vue_3.ref)({
            ...props.appointmentDatas,
        });
        //Ez a watch frissíti folyamatosan a ref copy értékét
        (0, vue_3.watch)(() => props.appointmentDatas, (newData) => {
            appointmentDatasCopy.value = { ...newData };
            appointmentDatasCopy.value.serviceId = 0;
            if (appointmentDatasCopy.value.booked_date &&
                appointmentDatasCopy.value.booked_time) {
                calendarSelectedDate.value = new Date((0, date_fns_1.format)(appointmentDatasCopy.value.booked_date, "yyyy-MM-dd") +
                    " " +
                    (0, date_fns_1.format)(appointmentDatasCopy.value.booked_time, "HH:mm"));
                handleMonthYear({
                    year: calendarYear.value,
                    month: calendarMonth.value,
                });
            }
        }, { immediate: true });
        wheelSizeStore.getCarBrands();
        //Autó adatok betöltése előre, ha van
        (0, vue_3.watch)(() => [appointmentDatasCopy.value], ([newAppointment]) => {
            if (newAppointment !== null &&
                newAppointment.car_make_slug &&
                newAppointment.car_year) {
                wheelSizeStore.getCarModells(newAppointment.car_make_slug);
                tipusActive.value = true;
                if (newAppointment.car_make_slug && newAppointment.car_model_slug) {
                    wheelSizeStore.getCarYears(newAppointment.car_make_slug, newAppointment.car_model_slug);
                    gyartEvActive.value = true;
                }
                if (newAppointment.car_type_slug) {
                    wheelSizeStore.getCarDetails(newAppointment.car_make_slug, String(newAppointment.car_year), String(newAppointment.car_model_slug));
                    kivitelActive.value = true;
                }
            }
        }, { immediate: false } // Azonnali futtatás kikapcsolva
        );
        //új szolgáltatások betöltése locationIdChangenél
        (0, vue_3.watch)(() => { var _a; return [(_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.locationId]; }, ([newLocationId]) => {
            if (newLocationId) {
                servicesStore.getAllservices(newLocationId);
            }
        }, { immediate: false } // Azonnali futtatás kikapcsolva
        );
        const closeModal = () => {
            modalOpen.value = false;
            emit("close");
        };
        const modalOpen = (0, vue_3.ref)(false);
        (0, vue_3.watch)(() => props.isOpen, (newValue) => {
            modalOpen.value = newValue;
        });
        //Auto adatok módosítása
        const changeCarBrand = (e) => {
            var _a;
            appointmentDatasCopy.value.car_make_slug = e.target.value;
            appointmentDatasCopy.value.car_make = (_a = wheelSizeStore.carBrands.find((item) => item.slug === e.target.value)) === null || _a === void 0 ? void 0 : _a.name;
            appointmentDatasCopy.value.car_model = "";
            appointmentDatasCopy.value.car_model_slug = "";
            appointmentDatasCopy.value.car_year = 0;
            appointmentDatasCopy.value.car_type = "";
            appointmentDatasCopy.value.car_type_slug = "";
            wheelSizeStore.getCarModells(appointmentDatasCopy.value.car_make_slug);
            gyartEvActive.value = false;
            kivitelActive.value = false;
            tipusActive.value = true;
        };
        const changeCarModel = (e) => {
            var _a;
            appointmentDatasCopy.value.car_model_slug = e.target.value;
            appointmentDatasCopy.value.car_model = (_a = wheelSizeStore.carModels.find((item) => item.slug === e.target.value)) === null || _a === void 0 ? void 0 : _a.name;
            appointmentDatasCopy.value.car_year = 0;
            appointmentDatasCopy.value.car_type = "";
            appointmentDatasCopy.value.car_type_slug = "";
            wheelSizeStore.getCarYears(String(appointmentDatasCopy.value.car_make_slug), appointmentDatasCopy.value.car_model_slug);
            gyartEvActive.value = true;
            kivitelActive.value = false;
        };
        const changeCarYear = (e) => {
            appointmentDatasCopy.value.car_type = "";
            appointmentDatasCopy.value.car_type_slug = "";
            appointmentDatasCopy.value.car_year = parseInt(e.target.value);
            wheelSizeStore.getCarDetails(String(appointmentDatasCopy.value.car_make_slug), String(appointmentDatasCopy.value.car_year), String(appointmentDatasCopy.value.car_model_slug));
            kivitelActive.value = true;
        };
        const changeCarEngine = (e) => {
            var _a;
            appointmentDatasCopy.value.car_type_slug = e.target.value;
            appointmentDatasCopy.value.car_type = (_a = wheelSizeStore.carDetails.find((item) => item.slug === e.target.value)) === null || _a === void 0 ? void 0 : _a.name;
        };
        const changeService = (e) => {
            var _a;
            appointmentDatasCopy.value.serviceId = parseInt(e.target.value);
            appointmentDatasCopy.value.service_name = (_a = servicesStore.services.find((item) => item.id === appointmentDatasCopy.value.serviceId)) === null || _a === void 0 ? void 0 : _a.name;
            handleMonthYear({
                year: calendarYear.value,
                month: calendarMonth.value,
            });
        };
        const handleInputChange = (key, value) => {
            if (appointmentDatasCopy.value[key] !== undefined && value !== undefined) {
                appointmentDatasCopy.value[key] = value;
            }
        };
        const changeChecboxValue = (key, value) => {
            if (appointmentDatasCopy.value[key] !== undefined && value !== undefined) {
                appointmentDatasCopy.value[key] = value;
            }
        };
        const debouncedHandleInputChange = (0, lodash_1.debounce)((key, value) => {
            if (appointmentDatasCopy.value[key] !== undefined &&
                value !== undefined) {
                appointmentDatasCopy.value[key] = value;
            }
        }, 300);
        /* For calendar */
        const calendarMarkers = (0, vue_3.ref)([]);
        const freeAppointmentsStore = (0, appointmentStore_1.useAppointmentStore)();
        const calendarYear = (0, vue_3.ref)(calendarSelectedDate.value.getFullYear());
        const calendarMonth = (0, vue_3.ref)(calendarSelectedDate.value.getMonth());
        const handleMonthYear = async ({ year, month, }) => {
            var _a, _b, _c, _d, _e, _f;
            calendarYear.value = year;
            calendarMonth.value = month;
            //it azért kell külön lekezelni mert az appointmentDatasCopy tömbben kinullázom az értékét a beállított szolgáltatás id-nek, innen tudom hogy nem akar változtatni
            let selectedService = 0;
            if ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.serviceId) {
                selectedService = (_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.serviceId;
            }
            else if ((_c = props.appointmentDatas) === null || _c === void 0 ? void 0 : _c.serviceId) {
                selectedService = (_d = props.appointmentDatas) === null || _d === void 0 ? void 0 : _d.serviceId;
            }
            await freeAppointmentsStore.getAppointments(year, month, (_f = (_e = appointmentDatasCopy.value) === null || _e === void 0 ? void 0 : _e.locationId) !== null && _f !== void 0 ? _f : 0, selectedService);
            calendarMarkers.value = [];
            Object.entries(freeAppointmentsStore.dates).forEach(([index, value]) => {
                let color = "grey";
                let tooltip = i18n_1.default.trans("calendar_no_open", "Color meaning: don't have opening time in that day", "vuepic_calendar");
                if (value.status == "0") {
                    color = "green";
                    tooltip = i18n_1.default.trans("calendar_has_enough_time", "Color meaning: this day has enough time to paste this appointment", "vuepic_calendar");
                }
                else if (value.status === "full") {
                    color = "red";
                    tooltip = i18n_1.default.trans("calendar_no_appointment", "Color meaning: no free appointments in that day", "vuepic_calendar");
                }
                calendarMarkers.value.push({
                    date: (0, addDays_1.default)(new Date(year +
                        "-" +
                        String(month + 1).padStart(2, "0") +
                        "-" +
                        String(value.monthDay).padStart(2, "0")), 0),
                    type: "line",
                    color: color,
                    tooltip: [
                        {
                            text: tooltip,
                            color: color,
                        },
                    ],
                });
            });
        };
        const selectedInternalDate = (0, vue_3.ref)(null);
        const handleInternal = (date) => {
            // Do something
            selectedInternalDate.value = date;
            /*calendarSelectedDate.value.setFullYear(date.getFullYear());
          calendarSelectedDate.value.setMonth(date.getMonth());
          calendarSelectedDate.value.setDate(date.getDate());*/
        };
        function formatDateDay(date) {
            const day = date.getDate();
            return day < 10 ? "0" + day : "" + day;
        }
        const dpRefDate = (0, vue_3.ref)(null);
        const dpRefTime = (0, vue_3.ref)(null);
        const activeDatePicker = (0, vue_3.ref)(null);
        const changeCalendarTime = (date) => {
            if (selectedInternalDate.value &&
                dpRefDate.value &&
                activeDatePicker.value === "date") {
                dpRefDate.value.closeMenu();
                calendarSelectedDate.value.setFullYear(selectedInternalDate.value.getFullYear());
                calendarSelectedDate.value.setMonth(selectedInternalDate.value.getMonth());
                calendarSelectedDate.value.setDate(selectedInternalDate.value.getDate());
                calendarSelectedDate.value.setHours(date.getHours());
                calendarSelectedDate.value.setMinutes(date.getMinutes());
                dpRefDate.value.openMenu();
            }
            else if (selectedInternalDate.value &&
                dpRefTime.value &&
                activeDatePicker.value === "time") {
                dpRefTime.value.closeMenu();
                calendarSelectedDate.value.setFullYear(selectedInternalDate.value.getFullYear());
                calendarSelectedDate.value.setMonth(selectedInternalDate.value.getMonth());
                calendarSelectedDate.value.setDate(selectedInternalDate.value.getDate());
                calendarSelectedDate.value.setHours(date.getHours());
                calendarSelectedDate.value.setMinutes(date.getMinutes());
                dpRefTime.value.openMenu();
            }
        };
        const changeAppointment = (modelData) => {
            var _a, _b;
            appointmentDatasCopy.value.booked_date = modelData;
            appointmentDatasCopy.value.booked_time = modelData;
            //bay Id kikeresése majd beállítása, az időpontból
            if (selectedInternalDate.value) {
                const bayId = (_b = (_a = freeAppointmentsStore.dates[formatDateDay(selectedInternalDate.value)].times.find((item) => (0, date_fns_1.format)(new Date(item.time), "HH:mm") ===
                    (0, date_fns_1.format)(new Date(String(appointmentDatasCopy.value.booked_time)), "HH:mm"))) === null || _a === void 0 ? void 0 : _a.bay) !== null && _b !== void 0 ? _b : 0;
                if (bayId) {
                    appointmentDatasCopy.value.bayId = bayId;
                }
            }
        };
        const acceptAppointment = () => {
            emit("approveAppointment", appointmentDatasCopy.value.id);
        };
        const declineAppointment = () => {
            emit("declineAppointment", appointmentDatasCopy.value.id);
        };
        const deleteAppointment = () => {
            emit("deleteAppointment", appointmentDatasCopy.value.id);
        };
        const saveAppointment = () => {
            emit("saveAppointment", appointmentDatasCopy.value);
        };
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", {
                        class: "modal-layer",
                        onClick: closeModal
                    }, null, 512), [
                        [vue_2.vShow, modalOpen.value && appointmentDatasCopy.value !== null]
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: "close-btn",
                                    onClick: closeModal
                                }, [
                                    (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fas', 'xmark'] })
                                ]),
                                (0, vue_2.createVNode)(ReservationModalColumn_vue_1.default, {
                                    title: _ctx.$trans('car_datas', 'Car datas', 'reservation_modal')
                                }, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b;
                                        return [
                                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                name: "license-plate",
                                                label: _ctx.$trans('license_plate', 'License plate', 'reservation_modal'),
                                                "max-length": 10,
                                                "model-value": (_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.plate_number,
                                                onKeyup: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(debouncedHandleInputChange)('plate_number', $event.target.value)))
                                            }, null, 8, ["label", "model-value"]),
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "marka",
                                                label: _ctx.$trans('car_brand', 'Brand', 'reservation_modal'),
                                                onChange: changeCarBrand
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("option", _hoisted_6, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carBrands, (brand) => {
                                                        var _a;
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: brand.slug,
                                                            value: brand.slug,
                                                            selected: brand.slug ===
                                                                ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.car_make_slug)
                                                        }, (0, vue_2.toDisplayString)(brand.name), 9, _hoisted_7));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["label"]),
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "tipus",
                                                label: _ctx.$trans('car_model', 'Model', 'reservation_modal'),
                                                active: tipusActive.value,
                                                onChange: changeCarModel
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("option", _hoisted_8, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carModels, (model) => {
                                                        var _a;
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: model.slug,
                                                            value: model.slug,
                                                            selected: model.slug ===
                                                                ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.car_model_slug)
                                                        }, (0, vue_2.toDisplayString)(model.name), 9, _hoisted_9));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["label", "active"]),
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "gyartasi_ev",
                                                label: _ctx.$trans('car_year', 'Year', 'reservation_modal'),
                                                active: gyartEvActive.value,
                                                onChange: changeCarYear
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("option", _hoisted_10, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carYears, (year) => {
                                                        var _a;
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: year.slug,
                                                            value: year.slug,
                                                            selected: parseInt(year.slug) ===
                                                                ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.car_year)
                                                        }, (0, vue_2.toDisplayString)(year.name), 9, _hoisted_11));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["label", "active"]),
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "kivitel",
                                                label: _ctx.$trans('car_engine', 'Engine', 'reservation_modal'),
                                                active: kivitelActive.value,
                                                onChange: changeCarEngine
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("option", _hoisted_12, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carDetails, (engine) => {
                                                        var _a;
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: engine.slug,
                                                            value: engine.slug,
                                                            selected: engine.slug ===
                                                                ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.car_type_slug)
                                                        }, (0, vue_2.toDisplayString)(engine.name), 9, _hoisted_13));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["label", "active"]),
                                            (((_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.status) === 'New')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomButton_vue_1.default, {
                                                    key: 0,
                                                    "btn-type": "success",
                                                    onClick: acceptAppointment
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("approve", "Approve", "reservation_modal")), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomButton_vue_1.default, {
                                                    key: 1,
                                                    "btn-type": "success",
                                                    onClick: saveAppointment
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("save", "Save", "reservation_modal")), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["title"]),
                                (0, vue_2.createVNode)(ReservationModalColumn_vue_1.default, {
                                    title: _ctx.$trans('tyre_and_service_title', 'Tyre and service', 'reservation_modal')
                                }, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b, _c, _d, _e, _f, _g, _h;
                                        return [
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "tyre_size",
                                                label: _ctx.$trans('tyre_size', 'Tyre size', 'reservation_modal'),
                                                onChange: _cache[1] || (_cache[1] = (e) => handleInputChange('rim_size', parseInt(e.target.value)))
                                            }, {
                                                default: (0, vue_2.withCtx)(() => {
                                                    var _a;
                                                    return [
                                                        (!((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.rim_size))
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", _hoisted_14, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(14, (coll) => {
                                                            var _a, _b;
                                                            return (0, vue_2.createElementVNode)("option", {
                                                                key: coll + 10,
                                                                value: coll + 10,
                                                                selected: ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.rim_size) !==
                                                                    undefined &&
                                                                    ((_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.rim_size) ===
                                                                        coll + 10
                                                            }, (0, vue_2.toDisplayString)(coll + 10) + "\" ", 9, _hoisted_15);
                                                        }), 64))
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["label"]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                (0, vue_2.createVNode)(CustomRadioWithImage_vue_1.default, {
                                                    "img-src": require('../../../../images/backend/modal-icons/tyre.png'),
                                                    name: 'is_wheel',
                                                    text: _ctx.$trans('without_rim', 'Without rim', 'reservation_modal'),
                                                    value: 'felni_nelkul',
                                                    checked: !appointmentDatasCopy.value.is_wheel,
                                                    onClick: _cache[2] || (_cache[2] = (e) => handleInputChange('is_wheel', false))
                                                }, null, 8, ["img-src", "text", "checked"]),
                                                (0, vue_2.createVNode)(CustomRadioWithImage_vue_1.default, {
                                                    "img-src": require('../../../../images/backend/modal-icons/tyreWithRim.png'),
                                                    name: 'is_wheel',
                                                    text: _ctx.$trans('with_rim', 'With rim', 'reservation_modal'),
                                                    value: 'felnivel',
                                                    checked: (_a = appointmentDatasCopy.value.is_wheel) !== null && _a !== void 0 ? _a : false,
                                                    onClick: _cache[3] || (_cache[3] = (e) => handleInputChange('is_wheel', true))
                                                }, null, 8, ["img-src", "text", "checked"])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                                    checked: (_b = appointmentDatasCopy.value.is_runflat) !== null && _b !== void 0 ? _b : false,
                                                    name: "is_runflat",
                                                    text: _ctx.$trans('runflat', 'Runflat', 'reservation_modal'),
                                                    onChangeValue: changeChecboxValue
                                                }, null, 8, ["checked", "text"]),
                                                (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                                    checked: (_c = appointmentDatasCopy.value.is_tpms) !== null && _c !== void 0 ? _c : false,
                                                    name: "is_tpms",
                                                    text: _ctx.$trans('tmps', 'TPMS', 'reservation_modal'),
                                                    onChangeValue: changeChecboxValue
                                                }, null, 8, ["checked", "text"]),
                                                (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                                    checked: (_d = appointmentDatasCopy.value.is_stored) !== null && _d !== void 0 ? _d : false,
                                                    name: "is_stored",
                                                    text: _ctx.$trans('stored_tyre', 'Stored tyre', 'reservation_modal'),
                                                    onChangeValue: changeChecboxValue
                                                }, null, 8, ["checked", "text"])
                                            ]),
                                            (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                                                name: "szolg",
                                                label: '*' +
                                                    _ctx.$trans('service', 'Service', 'reservation_modal'),
                                                active: ((_e = appointmentDatasCopy.value) === null || _e === void 0 ? void 0 : _e.source)
                                                    ? ['service', 'online'].includes(appointmentDatasCopy.value.source.toLowerCase())
                                                    : false,
                                                onChange: changeService
                                            }, {
                                                default: (0, vue_2.withCtx)(() => {
                                                    var _a, _b, _c;
                                                    return [
                                                        ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.service_name)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", _hoisted_18, (0, vue_2.toDisplayString)((_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.service_name) + " (" + (0, vue_2.toDisplayString)(_ctx.$trans("set", "set", "reservation_modal")) + ") ", 1))
                                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", _hoisted_19, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "reservation_modal")), 1)),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(servicesStore).filterByRimSize((_c = appointmentDatasCopy.value.rim_size) !== null && _c !== void 0 ? _c : 0), (service) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                key: service.id,
                                                                value: service.id
                                                            }, (0, vue_2.toDisplayString)(service.name), 9, _hoisted_20));
                                                        }), 128))
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["label", "active"]),
                                            (((_f = appointmentDatasCopy.value) === null || _f === void 0 ? void 0 : _f.status) === 'New')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomButton_vue_1.default, {
                                                    key: 0,
                                                    "btn-type": "danger",
                                                    onClick: declineAppointment
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("reject", "Reject", "reservation_modal")), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : (((_g = appointmentDatasCopy.value) === null || _g === void 0 ? void 0 : _g.status) ===
                                                    'Rejected' ||
                                                    ((_h = appointmentDatasCopy.value) === null || _h === void 0 ? void 0 : _h.status) === 'Approved')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CustomButton_vue_1.default, {
                                                        key: 1,
                                                        "btn-type": "danger",
                                                        onClick: deleteAppointment
                                                    }, {
                                                        default: (0, vue_2.withCtx)(() => [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("delete", "Delete", "reservation_modal")), 1)
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["title"]),
                                (0, vue_2.createVNode)(ReservationModalColumn_vue_1.default, {
                                    title: _ctx.$trans('label_appointment', 'Appointment', 'reservation_modal')
                                }, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b;
                                        return [
                                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_datepicker_1.default), {
                                                ref_key: "dpRefDate",
                                                ref: dpRefDate,
                                                modelValue: calendarSelectedDate.value,
                                                "onUpdate:modelValue": [
                                                    _cache[4] || (_cache[4] = ($event) => ((calendarSelectedDate).value = $event)),
                                                    changeAppointment
                                                ],
                                                "time-picker-inline": "",
                                                class: "date-picker",
                                                locale: currentLang.value,
                                                "enable-time-picker": true,
                                                "show-buttons": true,
                                                clearable: false,
                                                markers: calendarMarkers.value,
                                                position: "left",
                                                onInternalModelChange: handleInternal,
                                                onUpdateMonthYear: handleMonthYear,
                                                onOpen: _cache[5] || (_cache[5] = () => (activeDatePicker.value = 'date'))
                                            }, {
                                                "left-sidebar": (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)(_ctx.$trans("available_dated", "Available dates", "reservation_modal")), 1),
                                                        (selectedInternalDate.value &&
                                                            (0, vue_2.unref)(freeAppointmentsStore).dates[formatDateDay(selectedInternalDate.value)])
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(freeAppointmentsStore)
                                                                    .dates[formatDateDay(selectedInternalDate.value)].times, (times, index) => {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                        key: index,
                                                                        class: (0, vue_2.normalizeClass)({
                                                                            selected: (0, vue_2.unref)(date_fns_1.format)(new Date(calendarSelectedDate.value), 'HH:mm') ===
                                                                                (0, vue_2.unref)(date_fns_1.format)(new Date(times.time), 'HH:mm') &&
                                                                                (0, vue_2.unref)(date_fns_1.format)(new Date(calendarSelectedDate.value), 'yyyy-MM-dd') ===
                                                                                    (0, vue_2.unref)(date_fns_1.format)(new Date(selectedInternalDate.value), 'yyyy-MM-dd'),
                                                                        }),
                                                                        onClick: ($event) => (changeCalendarTime(new Date(times.time)))
                                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(date_fns_1.format)(new Date(times.time), "HH:mm")), 11, _hoisted_23));
                                                                }), 128))
                                                            ]))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ])
                                                ]),
                                                trigger: (0, vue_2.withCtx)(() => {
                                                    var _a;
                                                    return [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                            name: "date",
                                                            label: '*' +
                                                                _ctx.$trans('date', 'Date', 'reservation_modal'),
                                                            "model-value": ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.booked_date) instanceof
                                                                Date
                                                                ? (0, vue_2.unref)(date_fns_1.format)(appointmentDatasCopy.value.booked_date, 'yyyy.MM.dd')
                                                                : ''
                                                        }, null, 8, ["label", "model-value"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue", "locale", "markers"]),
                                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_datepicker_1.default), {
                                                ref_key: "dpRefTime",
                                                ref: dpRefTime,
                                                modelValue: calendarSelectedDate.value,
                                                "onUpdate:modelValue": [
                                                    _cache[6] || (_cache[6] = ($event) => ((calendarSelectedDate).value = $event)),
                                                    changeAppointment
                                                ],
                                                "time-picker-inline": "",
                                                class: "date-picker",
                                                locale: currentLang.value,
                                                "enable-time-picker": true,
                                                "show-buttons": true,
                                                clearable: false,
                                                markers: calendarMarkers.value,
                                                position: "left",
                                                onInternalModelChange: handleInternal,
                                                onUpdateMonthYear: handleMonthYear,
                                                onOpen: _cache[7] || (_cache[7] = () => (activeDatePicker.value = 'time'))
                                            }, {
                                                "left-sidebar": (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_24, (0, vue_2.toDisplayString)(_ctx.$trans("available_dated", "Available dates", "reservation_modal")), 1),
                                                        (selectedInternalDate.value &&
                                                            (0, vue_2.unref)(freeAppointmentsStore).dates[formatDateDay(selectedInternalDate.value)])
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(freeAppointmentsStore)
                                                                    .dates[formatDateDay(selectedInternalDate.value)].times, (times, index) => {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                        key: index,
                                                                        class: (0, vue_2.normalizeClass)({
                                                                            selected: (0, vue_2.unref)(date_fns_1.format)(new Date(calendarSelectedDate.value), 'HH:mm') ===
                                                                                (0, vue_2.unref)(date_fns_1.format)(new Date(times.time), 'HH:mm') &&
                                                                                (0, vue_2.unref)(date_fns_1.format)(new Date(calendarSelectedDate.value), 'yyyy-MM-dd') ===
                                                                                    (0, vue_2.unref)(date_fns_1.format)(new Date(selectedInternalDate.value), 'yyyy-MM-dd'),
                                                                        }),
                                                                        onClick: ($event) => (changeCalendarTime(new Date(times.time)))
                                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(date_fns_1.format)(new Date(times.time), "HH:mm")), 11, _hoisted_26));
                                                                }), 128))
                                                            ]))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ])
                                                ]),
                                                trigger: (0, vue_2.withCtx)(() => {
                                                    var _a, _b;
                                                    return [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                            name: "time",
                                                            label: '*' +
                                                                _ctx.$trans('label_appointment', 'Appointment', 'reservation_modal'),
                                                            "model-value": ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.booked_time) instanceof
                                                                Date
                                                                ? (0, vue_2.unref)(date_fns_1.format)((_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.booked_time, 'HH:mm')
                                                                : ''
                                                        }, null, 8, ["label", "model-value"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue", "locale", "markers"]),
                                            (0, vue_2.createVNode)(CustomTextArea_vue_1.default, {
                                                name: "megjegyzes",
                                                label: _ctx.$trans('label_comment', 'Comment', 'reservation_modal'),
                                                rows: 5,
                                                value: (_b = (_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.comment) !== null && _b !== void 0 ? _b : '',
                                                "max-length": 200,
                                                onKeyup: _cache[8] || (_cache[8] = ($event) => ((0, vue_2.unref)(debouncedHandleInputChange)('comment', $event.target.value)))
                                            }, null, 8, ["label", "value"])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["title"]),
                                (0, vue_2.createVNode)(ReservationModalColumn_vue_1.default, {
                                    title: _ctx.$trans('personal_datas', 'Personal datas', 'reservation_modal')
                                }, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b, _c;
                                        return [
                                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                name: "name",
                                                label: _ctx.$trans('name', 'Name', 'reservation_modal'),
                                                "model-value": (_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.name,
                                                "max-length": 45,
                                                onKeyup: _cache[9] || (_cache[9] = ($event) => ((0, vue_2.unref)(debouncedHandleInputChange)('name', $event.target.value)))
                                            }, null, 8, ["label", "model-value"]),
                                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                name: "email",
                                                label: _ctx.$trans('email', 'Email Address', 'reservation_modal'),
                                                "max-length": 320,
                                                "model-value": (_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.email,
                                                onKeyup: _cache[10] || (_cache[10] = ($event) => ((0, vue_2.unref)(debouncedHandleInputChange)('email', $event.target.value)))
                                            }, null, 8, ["label", "model-value"]),
                                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                name: "phone",
                                                label: _ctx.$trans('phone_number', 'Phone number', 'reservation_modal'),
                                                "max-length": 20,
                                                "model-value": (_c = appointmentDatasCopy.value) === null || _c === void 0 ? void 0 : _c.phone,
                                                onKeyup: _cache[11] || (_cache[11] = ($event) => ((0, vue_2.unref)(debouncedHandleInputChange)('phone', $event.target.value)))
                                            }, null, 8, ["label", "model-value"])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["title"]),
                                (0, vue_2.createVNode)(ReservationModalColumn_vue_1.default, null, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b, _c, _d;
                                        return [
                                            (__props.appointmentDatas !== null &&
                                                ((_a = appointmentDatasCopy.value) === null || _a === void 0 ? void 0 : _a.source))
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ModalBooking_vue_1.default, {
                                                    key: 0,
                                                    from: (_b = appointmentDatasCopy.value) === null || _b === void 0 ? void 0 : _b.source,
                                                    color: (_d = (_c = appointmentDatasCopy.value) === null || _c === void 0 ? void 0 : _c.sourceColor) !== null && _d !== void 0 ? _d : ''
                                                }, null, 8, ["from", "color"]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (appointmentDatasCopy.value.status)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ModalStatus_vue_1.default, {
                                                    key: 1,
                                                    status: appointmentDatasCopy.value.status
                                                }, null, 8, ["status"]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.createVNode)(CustomButton_vue_1.default, { onClick: closeModal }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("close", "Close", "reservation_modal")), 1)
                                                ]),
                                                _: 1
                                            })
                                        ];
                                    }),
                                    _: 1
                                })
                            ])
                        ])
                    ], 512), [
                        [vue_2.vShow, modalOpen.value && appointmentDatasCopy.value !== null]
                    ])
                ])
            ]));
        };
    }
});
